import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import './ConsultantTalentCard.scss';
import { analyticsTrack } from '../../../analyticsUtils';

const DEFAULT_NUM = 2;

// Taken from ConsultantSearchCard.jsx
const renderField = (attribute, icon, answer) => (
  <span className={`${attribute} body-text-2 normal-weight me-3`}>
    <i className={`fas ${icon} me-2`} />
    {answer}
  </span>
);

const renderProject = (project) => (
  <div className="g-row g-row--start-between">
    <div className="g-column">
      <a href={project.show_path} target="_blank" className="normal-weight body-text-2" rel="noreferrer">
        {project.project_name}
      </a>
    </div>

    {project.pending_review
      && (
      <div className="g-column">
        <a href={project.review_path} target="_blank" className="normal-weight body-text-2 green" rel="noreferrer">
          Review
        </a>
      </div>
      )}
  </div>
);

class ConsultantTalentCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentlyViewingMore: false,
      projectsToDisplay: props.consultant.projects.slice(0, DEFAULT_NUM),
      consultant: props.consultant,
      projects: props.consultant.projects,
    };

    this.toggleViewMore = this.toggleViewMore.bind(this);
  }

  toggleViewMore() {
    const { currentlyViewingMore, projects } = this.state;

    this.setState({
      currentlyViewingMore: !currentlyViewingMore,
      projectsToDisplay: !currentlyViewingMore ? projects : projects.slice(0, DEFAULT_NUM),
    });
  }

  renderHireAgainCTA() {
    const { consultant, projects } = this.state;

    return (
      <a
        className="btn btn-primary"
        target="_blank"
        href={consultant.consultant_hire_again_path}
        onClick={() => {
          analyticsTrack('Consultant hired again', { location: 'My Talent Page', consultant: consultant.name });
        }}
        rel="noreferrer"
      >
        {`${projects.length ? 'Hire again' : 'Hire'}`}
      </a>
    );
  }

  renderConsultantInfo() {
    const { consultant } = this.props;

    return (
      <div className="consultant-info">
        <div className="g-row g-row--start-between">
          <div className="g-column">
            <div className="name-and-rating medium-demibold body-text-2 mb-4">
              <a className="me-2" target="_blank" href={consultant.consultant_show_path} rel="noreferrer">
                {consultant.consultant_name}
              </a>
              {consultant.rating_avg
                && (
                <Fragment>
                  <StarRatings
                    rating={consultant.rating_avg}
                    isSelectable={false}
                    starRatedColor="#EDA318"
                    starHoverColor="#EDA318"
                    starDimension="14px"
                    starSpacing="2px"
                    numberOfStars={5}
                    name="rating"
                  />
                  <span className="ms-2">{consultant.rating_avg.toFixed(1)}</span>
                </Fragment>
                )}
            </div>
            <div className="roles body-text-2 normal-weight">
              {consultant.roles && consultant.roles.join('  |  ')}
            </div>
            <div className="years-and-levels mt-3">
              {consultant.years_experience
                && renderField('years-experience', 'fa-certificate', `${consultant.years_experience} years of experience`)}
              {consultant.seniority_levels && consultant.seniority_levels.length > 0
                && renderField('seniority-levels', 'fa-id-card-alt', consultant.seniority_levels.join(', '))}
            </div>
          </div>
          <div className="g-column ms-3">
            {this.renderHireAgainCTA()}
          </div>
        </div>
      </div>

    );
  }

  renderViewMore() {
    const { currentlyViewingMore } = this.state;
    const { consultant } = this.props;

    if (consultant.projects.length <= DEFAULT_NUM) {
      return null;
    }

    return (
      <a
        onClick={this.toggleViewMore}
        role="button"
        tabIndex="-1"
        className="body-text-2 medium-weight"
      >
        {currentlyViewingMore ? 'View less' : 'View all'}
      </a>
    );
  }

  renderProjectsInfo() {
    const { projectsToDisplay } = this.state;
    if (projectsToDisplay.length === 0) return null;

    return (
      <div className="projects-info mt-3">
        <div className="header medium-weight body-text-2">
          Projects with you
        </div>
        <div className="projects-table my-3">
          {
            projectsToDisplay.map((project, index) => (
              <div key={project.project_id} id={`project-${project.project_id}`}>
                {index > 0 && <hr className="mt-4 mb-4" />}
                {renderProject(project)}
              </div>
            ))
          }
        </div>
        {this.renderViewMore()}
      </div>
    );
  }

  render() {
    return (
      <div className="mb-3 consultant-talent-card">
        {this.renderConsultantInfo()}
        <hr className="ignore-padding" />
        {this.renderProjectsInfo()}
      </div>
    );
  }
}

ConsultantTalentCard.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
};

export default ConsultantTalentCard;
